import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { Autoplay } from "swiper/modules";
import { useEffect, useState } from "react";

interface sliderImages {
  images: string[],
}

const SliderRight = ({ images }: sliderImages) => {
  const [loadedImages, setLoadedImages] = useState<string[]>([]);

  const checkImagesLoaded = () => {
    const promises = images.map((src) => new Promise((resolve, reject) => {
      const img = new Image();
      img.src = src;
      img.onload = () => resolve(src);
      img.onerror = () => reject(src);
    }));

    Promise.all(promises)
      .then(() => setLoadedImages(images))
      .catch((error) => console.error("Erreur lors du chargement de l'image:", error));
  };

  
  useEffect(() => {
    checkImagesLoaded();
  }, [images]);

  // Si les images ne sont pas encore chargées, afficher un loader
  if (loadedImages.length === 0) {
    return <div>Loading...</div>;
  }

  const handleLeft = () => {
    return (
      <Swiper
        loop={true}
        slidesPerView={5}
        spaceBetween={2}
        autoplay={{
          delay: 1500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className="mySwiper"
      >
        {loadedImages.map((value, index) => (
          <SwiperSlide key={index + "slider"}>
            <img src={value} alt="blr galerie" />
          </SwiperSlide>
        ))}
      </Swiper>
    );
  };

  return (
    <>
      {
        handleLeft()
      }
    </>
  );
};

export default SliderRight;
